/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: metric-panel-row-component.ts
 *
 * Created by randysorensen on 2019-02-20.
 */

function MetricPanelRowController (
    this: JS5Object,
    MetricsDashboardService: JS5Object
) {

    this.showCurrentMonthData = () => {
        return MetricsDashboardService.currentCriteriaIncludesPresent();
    };

}

angular.module('prism-ui.metricsDashboard').component('metricPanelRow', {
    controller: MetricPanelRowController,
    templateUrl: 'dashboard/metrics/dashboard-panels/metric-panel-row/metric-panel-row-template.html',
    bindings: {
        currentMonthDataProperty: '<',
        monthlyDatasetProperty: '<',
        sumLabel: '<',
        sumDataProperty: '<'
    }
});
